<template>
  <div class="w-full bg-white">
    <!-- <b-sidebar v-model="isShowCMS" right shadow class="cms-sidebar-w">
      <template slot="title"
        ><h2 class="p-2 text-lg text-white">
          Content Management System
        </h2></template
      >
      <CMS
        :selectedId="selectedId"
        :isShowCMS="isShowCMS"
        @closePopup="closePopup2"
      />
    </b-sidebar> -->
    <div>
      <Banner />
    </div>

    <div class="lg:px-20 md:px-12 px-5">
      <div class="container mx-auto">
        <ACPSection />

        <div class="lg:pt-10 md:mt-10 mt-8">
          <h2
            id="2509722451"
            class="fsize24 text-232323 hoverText1 sm-fsize20 uppercase font-semibold mb-4"
          >
            {{ pageData ? pageData["2509722451"] : "FR panels" }}
          </h2>
          <Hexagonserie />
        </div>
        <div class="">
          <ACCPSection />
        </div>
        <div class="">
          <FireRetardant />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "./components/Banner.vue";
import ACPSection from "./components/ACPSection.vue";
import Hexagonserie from "../honey-pannel/components/Hexagonserie.vue";
import ACCPSection from "./components/ACCPSection.vue";
import FireRetardant from "./components/FireRetardant.vue";
import CMS from "../mainScreen1/CMSComponent/CMS";
import { mapState } from "vuex";

export default {
  data() {
    return {
      isShowCMS: false,
      pageData: {},
      selectedId: "",
      direction: "rtl",
    };
  },
  watch: {
    isShowCMS(newValue) {
      console.log(newValue);
    },
    pages(value) {
      this.pageData = value["FR ACP"];
    },
  },
  computed: {
    ...mapState("cms", ["pages", "user"]),
  },
  components: {
    Banner,
    ACPSection,
    ACCPSection,
    Hexagonserie,
    FireRetardant,
    CMS,
  },
  metaInfo: {
    title:
      "Fireproof Your Buildings: FR ACP Fire Retardant Panels for Fire Safety",
    meta: [
      {
        name: "description",
        content:
          "Eurobond offers the best Fire Retardant Panels - fireproof, no toxic smoke, no droplets, tested & certified FR ACP with 3 hour fire rating and EN 13501 class rating",
      },
      {
        rel: "canonical",
        href: "https://www.eurobondacp.com/aluminium-hpl-sheet/",
      },
    ],
  },
  methods: {
    async removeClass() {
      let classData = document.getElementsByClassName("hoverText1");

      const elementsArray = Array.from(classData);

      elementsArray.forEach((element) => {
        element.classList.remove("hoverText1");
      });
    },

    addClass() {
      let classData2 = document.getElementsByClassName("hoverText1");

      let classData = document.getElementsByClassName("hoverText1");
      console.log(classData, "home");
      for (let i = 0; i < classData.length; i++) {
        classData[i].classList.add("hoverText1");
        if (classData[i]) {
          console.log(classData[i].id, "ids");
          classData[i].addEventListener("click", () => {
            this.selectedId = classData[i].id;
            console.log(this.selectedId, "selected");
            this.isShowCMS = true;
          });
        }
      }
    },

    async closePopup2() {
      console.log("close");
      this.isShowCMS = false;
      let cms = { projectName: process.env.VUE_APP_COMMUNITY_NAME };
      await this.$store.dispatch("cms/getClientCms", cms);
    },
    init() {
      let popVal = localStorage.getItem("pop");
      let val = Boolean(popVal);
      if (!val) {
        localStorage.setItem("pop", false);
      } else {
        localStorage.setItem("pop", true);
        let pop = localStorage.getItem("pop");
        this.AdPopup = Boolean(pop);
      }
    },
    async closeModal() {
      localStorage.setItem("pop", false);
      this.AdPopup = false;
    },
  },
  async mounted() {
    this.init();
    if (this.pages) {
      this.pageData = this.pages["FR ACP"];
    }

    if (this.$route.query.token === "123") {
      console.log("CMS Active");
      await this.addClass();
    } else {
      await this.removeClass();
    }
  },
};
</script>
